<template>
    <slot name="footer">
        <!-- <Loading />
        <AlertDialog />
        <ConfirmDialog /> -->
    </slot>
</template>

<script>

import Loading from '@/components/loading.vue'
import AlertDialog from '@/components/dialog/alert.vue'
import ConfirmDialog from '@/components/dialog/confirm.vue'

export default {
    components: {
        Loading,
        AlertDialog,
        ConfirmDialog
    },
    data: function() {
        return {
            cont: '이것은 확인창인디'
        }
    },
    methods: {
        init: function() {
            // this.setShowNavi(window.location.href);
            // let ok = this.$refs.modal.show();
            // ok.then(function(res) {
            //     console.log(res);
            //     if ( res ) {
            //         console.log('ok');
            //     } else {
            //         console.log('cancel');
            //     }
            // });
        },
        // setShowNavi: function(path) {
        //     this.IS_SHOW_NAVI = false;
        //     for ( let i = 0 ; i < this.SHOW_NAVI_URL_LIST.length ; i++ ) {
        //         if ( path.indexOf(this.SHOW_NAVI_URL_LIST[i]) > -1 ) {
        //             this.IS_SHOW_NAVI = true;
        //         }
        //     }
        //     console.log(path + "/" + this.IS_SHOW_NAVI);
        // },
    },
    watch: {
        // route (to, from) {
            // this.loader(to.path);
            // console.log(from.path + '->' + to.path);
            // this.setShowNavi(to.path);

            // if ( from.path.indexOf('signUpMember') > -1 && to.path.indexOf('signIn') > -1 ) {
            //     router.push('/home');
            // }

            // LayerUtil.init();
        // }
    },
    created() {
        
    },
    beforeUnmount(){
        
    },
    mounted() {
        this.init();
    }
}
</script>
